const Countries = {
  HONG_KONG: 'HK',
  SINGAPORE: 'SG',
  TAIWAN: 'TW',
  CHINA: 'CN',
  VIETNAM: 'VN',
}

export default Countries
